import { message } from 'antd';
import { LooseOrderSubtype } from 'types';
import API, { CreateLooseOrderDto } from '../../../../API';

export const useNewBigBagOrder = () => {
	const createOrder = async (data: Omit<CreateLooseOrderDto, 'subtype'>, isNewAddress: boolean) => {
		try {
			if (isNewAddress) {
				await API.addresses.add({
					name: data.address,
					clientId: data.clientId,
				});
			}

			return await API.looseOrders.create({
				...data,
				subtype: LooseOrderSubtype.BigBag,
			});
		} catch (e) {
			console.error(e);

			message.error(`Nie udało się dodać zamówienia (${e})`);

			return undefined;
		}
	};

	return { createOrder };
};
